export const validateTransportationFeeConfig = (text) => {
    try {
        const json = JSON.parse(text);
        const isValidStructure = json.every(
            (item) =>
                typeof item === "object" &&
                item !== null &&
                "range" in item &&
                "feeAmount" in item &&
                typeof item.range === "string" &&
                typeof item.feeAmount === "number",
        );
        return isValidStructure;
    } catch {
        return false;
    }
};
